import React from 'react';
import Spinner from '../../../common/Spinner/Spinner';
import Button from '../../../common/button/Button';

const OpenAppPageComponent = () => (
    <div className="openAppSection">
        <Spinner />
        <h1>Aguarde enquanto o aplicativo abre</h1>
        <div>
            <p>
                Se você ainda não instalou o aplicativo, baixe agora.
                <br />
                Disponível para iOS e Android:
            </p>
            <div className="appsButtons">
                <Button href="https://itunes.apple.com/br/app/id378370013?mt=8" title="Baixar na Apple Store">
                    <img src="/imgAplicativosPage/appstore-button-2x.png" alt="Icone baixar na Apple Store" />
                </Button>
                <Button href="https://play.google.com/store/apps/details?id=br.com.mobits.antena1" title="Baixar no Google Play">
                    <img src="/imgAplicativosPage/playstore-button-2x.png" alt="Icone baixar no Google Play" />
                </Button>
            </div>
        </div>
        <div>
            <p>
                Conheça também os nossos outros aplicativos,
                <br />
                acesse aqui:
            </p>
            <div className="aplicativosButton">
                <Button to="/aplicativos" title="Conheçe todos os nossos aplicativos oficiais">
                    <img src="/imgAplicativosPage/all-apps-button-2x.png" alt="Icone para a página com todos os nossos aplicativos" />
                </Button>
            </div>
        </div>
    </div>
);

export default OpenAppPageComponent;
